// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"spinner_wrapper__qstiT","spinner":"spinner_spinner__qyhV2"};